import React from 'react';

import {
  TypeAutoriteFourriereDto,
  TypeAutoriteFourriereViolationDtoFormFieldEnum,
} from 'lib_api/lib/api/gen';

import { useApi } from 'hooks/ApiStoreContext';
import { useSubmitReferentielForm } from 'hooks/referentiels/useSubmitReferentielForm';
import { useValidateReferentielForm } from 'hooks/referentiels/useValidateReferentielForm';
import { TypeAfFormValues } from 'types/referentiels/TypeAf';

import { buildFormValues, buildRequestDto } from '../utils';

import { ModalEditionTypeAf } from './ModalEditionTypeAf';

interface ModalCreateProps {
  typeAutoriteFourriere: TypeAutoriteFourriereDto;
  visible: boolean;
  close: () => void;
  refreshDashboard: () => void;
}

function ModalUpdate({
  typeAutoriteFourriere,
  visible,
  close,
  refreshDashboard,
}: ModalCreateProps): React.ReactElement {
  const initials: TypeAfFormValues = buildFormValues(typeAutoriteFourriere);
  const { AdminFonctionnelControllerApi } = useApi();
  const { submit, inProgress } = useSubmitReferentielForm(
    refreshDashboard,
    close,
    (values: TypeAfFormValues) =>
      AdminFonctionnelControllerApi.updateTypeAfUsingPUT(
        typeAutoriteFourriere.idCorrelation,
        buildRequestDto(values),
      ),
  );
  const { validate } = useValidateReferentielForm(
    (
      field: TypeAutoriteFourriereViolationDtoFormFieldEnum,
      values: TypeAfFormValues,
    ) =>
      AdminFonctionnelControllerApi.validateUpdateTypeAfFieldUsingPOST(
        field,
        typeAutoriteFourriere.idCorrelation,
        buildRequestDto(values),
      ),
    response => response.typeAutoriteFourriereViolationDto ?? [],
  );

  return (
    <ModalEditionTypeAf
      close={close}
      initials={initials}
      isSubmitting={inProgress}
      submit={submit}
      visible={visible}
      title={"Mise à jour du type d'autorité de fourrière"}
      validate={validate}
    />
  );
}

export default ModalUpdate;
